export default __webpack_public_path__ + "static/media/Foto10.4e0f4098.png";